import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './translations/de.json';
import en from './translations/en.json';

i18n.use(initReactI18next).init({
  returnNull: false,
  returnObjects: false,
  resources: {
    en: {
      translation: en,
    },
    de: {
      translation: de,
    },
  },
  lng: 'de',
  interpolation: {
    escapeValue: false,
  },
});

// @ts-ignore
// biome-ignore lint/style/noDefaultExport: necessary for i18n
export default i18n;
